import {
  ChangeDetectionStrategy,
  Component,
  computed,
  DestroyRef,
  effect,
  ElementRef,
  inject,
  input,
  model,
  output,
  signal,
  viewChild,
} from '@angular/core';
import { Sparte } from '@mwe/models';
import { NgbDropdown, NgbDropdownButtonItem, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle } from '@ng-bootstrap/ng-bootstrap';
import { NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { TranslateCategoryPipe } from '@mwe/ui/pipes';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { tap } from 'rxjs/operators';
import ShortUniqueId from 'short-unique-id';

@Component({
  selector: 'mwe-category-dropdown-filter',
  templateUrl: './category-dropdown-filter.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgbDropdown,
    NgbDropdownToggle,
    NgbDropdownMenu,
    NgbDropdownButtonItem,
    NgbDropdownItem,
    NgClass,
    TranslatePipe,
    TranslateCategoryPipe,
  ],
})
export class CategoryDropdownFilterComponent {
  destroyRef = inject(DestroyRef);
  readonly categoryOptions = input<Sparte[]>([]);
  readonly selectedCategory = model<Sparte>();
  readonly onSelectedCategory = output<Sparte>();
  readonly dropdown = viewChild(NgbDropdown);
  readonly buttonEle = viewChild<ElementRef<HTMLButtonElement>>('buttonElement');
  readonly selectedCategoryIndex = signal<number>(0);
  private readonly _componentId = signal<string>(new ShortUniqueId({ dictionary: 'alpha' }).rnd(8));
  readonly isCollapsed = signal<boolean>(true);
  readonly dropdownId = computed<string>(() => `${this._componentId()}_dropdown`);
  readonly buttonId = computed<string>(() => `${this._componentId()}_button`);

  constructor() {
    effect(() => {
      this.dropdown()
        ?.openChange?.pipe(
          takeUntilDestroyed(this.destroyRef),
          tap(isOpen => this.isCollapsed.set(!isOpen)),
        )
        .subscribe();
    });
  }

  isFernwaermeTariffClass(sparte: Sparte): boolean {
    return ['HEIZUNG', 'WARMWASSER', 'HEIZUNG_WARMWASSER', 'KALT-/ABWASSER', 'KALT_ABWASSER'].includes(sparte);
  }

  selectCategory(category: Sparte, index: number): void {
    this.selectedCategory.set(category);
    this.selectedCategoryIndex.set(index);
    this.onSelectedCategory.emit(this.selectedCategory());
    this.buttonEle().nativeElement.focus();
  }
}
